import { useMemo } from 'react';

export function useGroupedMessages(messages = []) {
  return useMemo(() => {
    if (!messages.length) return null;

    const now = new Date();
    const todayStart = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const yesterdayStart = new Date(todayStart);
    yesterdayStart.setDate(todayStart.getDate() - 1);

    return messages.reduce((acc, msg, index) => {
      const targetId = msg?.props?.message?.id;

      // ✅ Check if already exists in accumulator
      const exists = Object.values(acc).some((group) =>
        group?.some((m) => m?.props?.message?.id === targetId)
      );

      if (exists && targetId) {
        return acc;
      }

      if (Object.values(acc)[0]?.length > 0) {
        if (msg?.props?.message?.type === 'multiChoice' && index !== 0) {
          msg?.props?.message?.content?.options?.map((option) => {
            option['disabled'] = true;
            return option;
          });
        }
      }

      const messageDate = new Date(msg?.props?.message?.timeStamp ?? msg?.timestamp);
      let currentLabel;
      if (messageDate >= todayStart) {
        currentLabel = 'Today';
      } else if (messageDate >= yesterdayStart) {
        currentLabel = 'Yesterday';
      } else {
        currentLabel = messageDate.toLocaleDateString();
      }
      if (!acc[currentLabel]) acc[currentLabel] = [];
      acc[currentLabel].push(msg);
      // console.log(acc);

      return acc;
    }, {});
  }, [messages]);
}

// export function useGroupedMessages(messages) {
//   return useMemo(() => {
//     if (!Array.isArray(messages) || messages.length === 0) return [];

//     const now = new Date();
//     const todayStart = new Date(now.getFullYear(), now.getMonth(), now.getDate());
//     const yesterdayStart = new Date(todayStart);
//     yesterdayStart.setDate(todayStart.getDate() - 1);

//     const acc = {};

//     messages?.map((msg, index) => {
//       if (msg?.props?.message?.type === 'multiChoice' && index !== 0) {
//         const options = msg?.props?.message?.content?.options;
//         options.length > 0 && options.map((option) => (option.disabled = true));
//       }
//       const messageDate = new Date(msg?.props?.message?.timeStamp ?? msg?.timestamp);
//       let currentLabel;
//       if (messageDate >= todayStart) {
//         currentLabel = 'Today';
//       } else if (messageDate >= yesterdayStart) {
//         currentLabel = 'Yesterday';
//       } else {
//         currentLabel = messageDate.toLocaleDateString();
//       }

//       if (!acc[currentLabel]) acc[currentLabel] = [];
//       acc[currentLabel].push(msg);
//     });

//     return Object.entries(acc); // [[dateLabel, [msg1, msg2...]], ...]
//   }, [messages]);
// }
